import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	padding: 6px 0 26px 0;
`;

export const Section = styled.div`
	display: flex;
	flex-direction: column;
	padding-right: 70px;

	&:last-child {
		flex-grow: 1;
	}
`;

export const RowSection = styled.div`
	display: flex;
	flex-direction: row;

	& > div {
		flex-grow: 1;
	}
`;

export const SectionWrapper = styled.div`
	${Section}:first-child {
		min-width: 320px;
	}

	${Section}:last-child {
		padding-right: 0;
	}

	& + & {
		margin-top: 30px;
		display: block;

		${Section}:first-child {
			padding-bottom: 16px;
		}
	}
`;

export const Title = styled.div`
	font-weight: 500;
	font-size: 16px;
	letter-spacing: 0.3px;
	margin-bottom: 8px;
	color: ${colors.grey7};
`;

export const Description = styled.div`
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.8px;
	color: ${colors.grey5};
`;

export const RadioWrapper = styled.div`
	position: relative;
	padding-top: 18px;

	span {
		font-size: 13px;
		font-style: normal;
		font-weight: 500;
		line-height: 32px;
		letter-spacing: 0.3px;
	}

	${Description} {
		padding: 8px 0 0 32px;
		min-width: 260px;
	}
`;

export const InfoIconWrapper = styled.div`
	cursor: pointer;
	display: inline-flex;
	position: relative;
	top: 4px;
	left: 6px;
`;
